module.exports = __webpack_public_path__ + "static/media/8.4c909ea1.jpg";